/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import globalStyle from '../../../global.scss?inline';
import style from './ScoreButtonList.scss?inline';
import { List, ListItem, ListItemButton, Typography } from '@mui/material';
import { useCSS } from '../../../provider/CSSProvider';
import { convertToRomanNumber } from '../../../utils/util';

export type ScoreButtonLabel = string;

interface ScoreButtonProps<T> {
  title?: string;
  reverse: boolean;
  listOfEntries: ReadonlyArray<readonly [T, ScoreButtonLabel]>;
  selectedValue: T | null;
  /**
   * When true, roman scores are displayed.
   */
  romanScores?: boolean;
  onChange: (value: T | null) => void;
}
function ScoreButtonList<T>(props: ScoreButtonProps<T>) {
  useCSS(style);
  useCSS(globalStyle);

  const { title, reverse, listOfEntries, selectedValue, romanScores, onChange } = props;

  function getScoreLabel(score: number): string {
    if (romanScores) {
      return convertToRomanNumber(score);
    } else {
      return score.toString();
    }
  }

  const ListButtons = listOfEntries.map(([value, label], index) => (
    <ListItem key={label}>
      <ListItemButton
        selected={value === selectedValue}
        onClick={() => onChange(selectedValue === value ? null : value)}>
        <div className='option'>
          <div className='score'>{getScoreLabel(index + 1)}</div>
          <div className='label'>{label}</div>
        </div>
      </ListItemButton>
    </ListItem>
  ));

  return (
    <div className='score-button-list'>
      {title && (
        <Typography align='left' className='title'>
          {title}
        </Typography>
      )}
      <List className={'reverse-' + reverse}>{ListButtons}</List>
    </div>
  );
}

export default ScoreButtonList;
